
angular.module('bmsApp.employeeHoliday', [])

	.config([
		'$stateProvider',
		'$urlRouterProvider',
		'BMSPermission', function config(
			$stateProvider,
			$urlRouterProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.employee.index.holidays', {
					url: '/holidays',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employeeHoliday/templates/employeeHolidayIndex.html"
						}
					},
					ncyBreadcrumb: {label: 'Holidays'}
				})

				;

		}]);
	